import React from 'react';
import { Box, Divider } from 'vindi-ds-components';
import { PrFile } from 'vindi-ds-icons/pr';
import styles from '../styles';

import ReportCard from './reportCard';

function CardsRenewalReport({ isMobile }) {
  return (
    <>
      {!isMobile && <Divider spacing='xs' />}

      <Box css={!isMobile && styles.root}>
        <ReportCard
          icon={<PrFile />}
          isMobile={isMobile}
          name='Renova Cartões'
          links={[{
            route: 'reports/cards_renewal',
          }]}
        />
      </Box>
    </>
  );
}

export default CardsRenewalReport;
